/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportConvenienceDoorsV2MutationRequest,
  ExportConvenienceDoorsV2MutationResponse,
  ExportConvenienceDoorsV2400,
  ExportConvenienceDoorsV2500,
} from '../types/ExportConvenienceDoorsV2'

function getExportConvenienceDoorsV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/places/convenience-doors/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async convenience doors export.
 * @summary Start an async convenience doors export
 * {@link /api/v1/places/convenience-doors/export/v2/}
 */
export async function exportConvenienceDoorsV2(
  data: ExportConvenienceDoorsV2MutationRequest,
  config: Partial<RequestConfig<ExportConvenienceDoorsV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportConvenienceDoorsV2MutationResponse,
    ResponseErrorConfig<
      ExportConvenienceDoorsV2400 | ExportConvenienceDoorsV2500
    >,
    ExportConvenienceDoorsV2MutationRequest
  >({
    method: 'POST',
    url: getExportConvenienceDoorsV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
